import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import  '../Hero/Hero.scss'
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { ReactComponent as Arrow } from "../../svg/arrow.svg";



const Hero = () =>{

    return(
        
            <section className="hero">
                <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                delay: 2500,
                disableOnInteraction: false,
                }}
                pagination={{
                clickable: true,
                }}
                navigation={false}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide><img className="header__hero-img" src="/img/mac.jpg"  alt="apple" /></SwiperSlide>
                <SwiperSlide><img className="header__hero-img" src="/img/Apple-Watch.jpg"  alt="apple" /></SwiperSlide>
                <SwiperSlide><img className="header__hero-img" src="/img/ipad.jpg"  alt="apple" /></SwiperSlide>
                <SwiperSlide><img className="header__hero-img" src="/img/imac.jpg"  alt="apple" /></SwiperSlide>
            </Swiper>
            <div className="hero__title-wrapper">
                <h2 className="hero__title">In our store "U store" you can buy only tested and high-quality used gadgets and accessories for them. iPhones, Applewatches, iPads, MacBooks.</h2>
            </div>
            
            <div className="hero__scroll-down">
                <Arrow className='hero__scroll-down--icon'/>
            </div>

        </section>
      
  );
}

    


export default Hero;


